"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.reflect.get");

require("core-js/modules/es6.regexp.replace");

var _TextField = _interopRequireDefault(require("../textfield/TextField"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PasswordComponent =
/*#__PURE__*/
function (_TextFieldComponent) {
  _inherits(PasswordComponent, _TextFieldComponent);

  function PasswordComponent() {
    _classCallCheck(this, PasswordComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(PasswordComponent).apply(this, arguments));
  }

  _createClass(PasswordComponent, [{
    key: "createInput",
    value: function createInput(container) {
      if (!this.isMultipleMasksField) {
        var _inputGroup = _get(_getPrototypeOf(PasswordComponent.prototype), "createInput", this).call(this, container);

        var passwordViewControl = this.ce('button', {
          class: 'password-view-control',
          onclick: this.onPassportViewChange.bind(this)
        });
        container.classList.add('password');
        container.appendChild(passwordViewControl);
        this.addCounter(container);
        this.contaner = container;
        return _inputGroup;
      } //if component should have multiple masks


      var attr = this.info.attr;
      attr.class += ' formio-multiple-mask-input';
      var textInput = this.ce('input', attr);
      var inputGroup = this.ce('div', {
        class: 'input-group formio-multiple-mask-container'
      });
      this.addPrefix(textInput, inputGroup);
      var maskInput = this.createMaskInput(textInput);
      this.addTextInputs(textInput, maskInput, inputGroup);
      this.addSuffix(textInput, inputGroup);
      this.errorContainer = container;
      this.setInputStyles(inputGroup);
      this.addCounter(inputGroup);
      container.appendChild(inputGroup);
      return inputGroup;
    }
  }, {
    key: "createViewOnlyValue",
    value: function createViewOnlyValue(container) {
      this.valueElement = this.ce('dd', {
        class: 'password-view'
      });
      this.setupValueElement(this.valueElement);
      container.appendChild(this.valueElement);
    }
  }, {
    key: "setupValueElement",
    value: function setupValueElement(element) {
      var value = this.getValue().replace(/./gm, '&#9679;');
      value = this.isEmpty(value) ? this.defaultViewOnlyValue : this.getView(value);
      element.innerHTML = value;
    }
  }, {
    key: "onPassportViewChange",
    value: function onPassportViewChange() {
      var passwordControl = this.contaner.querySelector('.form-control');
      var passwordViewControl = this.contaner.querySelector('.password-view-control');

      if (passwordViewControl && passwordControl) {
        passwordViewControl.classList.toggle('password-view-control--show');

        if (passwordControl.getAttribute('type') === 'password') {
          passwordControl.setAttribute('type', 'text');
        } else {
          passwordControl.setAttribute('type', 'password');
        }
      }
    }
  }, {
    key: "elementInfo",
    value: function elementInfo() {
      var info = _get(_getPrototypeOf(PasswordComponent.prototype), "elementInfo", this).call(this);

      info.attr.type = 'password';
      info.attr.style = 'padding-right: 40px !important';
      return info;
    }
  }, {
    key: "defaultSchema",
    get: function get() {
      return PasswordComponent.schema();
    }
  }], [{
    key: "schema",
    value: function schema() {
      for (var _len = arguments.length, extend = new Array(_len), _key = 0; _key < _len; _key++) {
        extend[_key] = arguments[_key];
      }

      return _TextField.default.schema.apply(_TextField.default, [{
        type: 'password',
        label: 'Password',
        key: 'password'
      }].concat(extend));
    }
  }, {
    key: "builderInfo",
    get: function get() {
      return {
        title: 'Password',
        icon: 'fa fa-asterisk',
        group: 'basic',
        documentation: 'http://help.form.io/userguide/#password',
        weight: 20,
        schema: PasswordComponent.schema()
      };
    }
  }]);

  return PasswordComponent;
}(_TextField.default);

exports.default = PasswordComponent;